import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";
import { Words } from "./landing/Hero";
import { scrollToY } from "./ScrollControls";
import { useLang } from "../context/LanguageContext";

export const PageHero = ({ overline, title, sub, testid, img = "/assets/hero-3.jpg", children }) => {
  const { t, isRtl } = useLang();
  return (
    <section className="relative min-h-[88vh] flex items-end overflow-hidden bg-[#1B2A4E]" data-testid="page-hero">
      <motion.img
        src={img}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover object-top"
        initial={{ scale: 1.15, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-gradient-to-r rtl:bg-gradient-to-l from-[#1B2A4E]/95 via-[#1B2A4E]/70 to-[#1B2A4E]/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4E] via-[#1B2A4E]/30 to-[#1B2A4E]/40" />
      <div className="absolute inset-0 dot-grid opacity-30 mix-blend-overlay" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-12 w-full pt-44 pb-24">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }} className="flex items-center gap-3 text-[11px] font-bold tracking-[0.25em] uppercase text-[#F5A623] mb-6">
          <Link to="/" className="text-white/60 hover:text-white transition-colors" data-testid="page-hero-home-link">{t("nav.home")}</Link>
          <span className="w-8 h-px bg-[#F5A623]" />
          {overline}
        </motion.div>
        <h1 className={`font-head font-black text-4xl sm:text-6xl xl:text-7xl text-white tracking-tight max-w-4xl ${isRtl ? "leading-[1.35]" : "leading-[1.04]"}`} data-testid={testid}>
          <Words text={title} step={0.07} />
        </h1>
        {sub && (
          <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.7 }} className="text-white/75 mt-6 max-w-2xl text-base sm:text-lg leading-relaxed">
            {sub}
          </motion.p>
        )}
        {children && <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.9 }} className="mt-8">{children}</motion.div>}
      </div>
      <button
        data-testid="page-hero-scroll"
        onClick={() => scrollToY(window.innerHeight * 0.85)}
        className="absolute bottom-8 start-6 sm:start-12 flex items-center gap-3 text-white/70 hover:text-white text-[11px] font-bold tracking-[0.25em] uppercase transition-colors"
      >
        {t("hero.scroll")}
        <motion.span animate={{ y: [0, 8, 0] }} transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }} className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center">
          <ArrowDown className="w-4 h-4" />
        </motion.span>
      </button>
    </section>
  );
};
